const coinbaseDeeplink = (url: string) => `https://go.cb-w.com/dapp?cb_url=${encodeURIComponent(url)}`

export default coinbaseDeeplink